// Libs
import React from 'react';
import { Modal, Form } from 'react-bootstrap';
import ExpandingTextArea from 'react-expanding-textarea';

// Services & Helpers
import BootboxHelper from 'helpers/BootboxHelper';
import SupportService from 'services/SupportService';

// Components
import Loader from 'components/common/Loader';

//-------------------------------------------------------------------------------------------------------------------

class SubmitSupportTicketModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    show(opts) {
        return new Promise((resolve, reject) => {
            this.opts = opts;
            this.setState({
                isOpen: true,
                isLoading: true
            }, () => {
                this.load();
            });
        });
    }

    async load() {
        const areas = await SupportService.listAreas();
        const areaID = areas[0].id;
        const templates = await SupportService.listTemplates(areaID);
        this.setState({
            supportTicket: {
                areaID: areaID,
                templateID: templates[0].id 
            },
            areas,
            templates,
            isLoading: false
        });
    }

    close() {
        this.setState({ isOpen: false });
    }

    updateFields(values, callback) {
        const supportTicket = { ...this.state.supportTicket };
        let loadTemplates;
        for (var fieldName in values) {
            let value = values[fieldName];
            supportTicket[fieldName] = value;

            switch (fieldName) {
                case 'areaID':
                    loadTemplates = true;
                    break;
            }
        }
        this.setState({
            supportTicket
        }, async () => {
            if (callback) {
                callback();
            }
            if (loadTemplates) {
                //this.setState({ isLoadingTemplates: true });
                const templates = await SupportService.listTemplates(supportTicket.areaID);
                this.setState({
                    isLoadingTemplates: false,
                    templates
                });
            }
        });
    }

    async save() {
        const { supportTicket } = this.state;
        return new Promise(async (resolve) => {
            this.setState({ isLoading: true });
            try {
                const id = await SupportService.submitTicket(supportTicket);
                this.setState({
                    isLoading: false
                }, () => {
                    BootboxHelper.alert('Thank you, your support request has been submitted. We will be in touch within the next 48 hours.');
                    resolve(id);
                });
            } catch (error) {
                BootboxHelper.alert(error);
                this.setState({ isLoading: false });
            }
        });
    }

    async saveAndClose() {
        if (this.state.isLoading) return;
        await this.save();
        this.close();
        this.resolve();
    }

    render() {
        const { isOpen, isLoading } = this.state;
        if (!isOpen) {
            return null;
        }

        return (
            <Modal show className="submit-support-ticket-modal">
                <div className="modal-header">
                    <h5>Request Support</h5>
                </div>
                <form onSubmit={e => { e.preventDefault(); this.saveAndClose() }}>
                    <Modal.Body>
                        {this.renderInner()}
                    </Modal.Body>
                    {!isLoading &&
                        <Modal.Footer>
                            <button type="button" className="btn btn-secondary me-auto" onClick={() => this.close()}>
                                Cancel
                            </button>
                            <button type="submit" className="btn btn-primary ms-auto">
                                Submit Support Request
                            </button>
                        </Modal.Footer>
                    }
                </form>
            </Modal>
        );
    }
    
    renderInner() {
        const {
            isLoading,
            areas,
            supportTicket,
            templates,
            isLoadingTemplates
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (<>

            <Form.Group className="mb-3">
                <Form.Label>Area</Form.Label>
                <select 
                    className="form-control"
                    value={supportTicket.areaID || ''}
                    onChange={e => this.updateFields({ areaID: e.target.value })}
                >
                    {areas.map(sta =>
                        <option key={sta.id} value={sta.id}>
                            {sta.name}
                        </option>
                    )}
                </select>
            </Form.Group>

            {isLoadingTemplates ? <Loader isInline /> : <>
                <Form.Group className="mb-3">
                    <Form.Label>Nature of request</Form.Label>
                    <select
                        className="form-control"
                        value={supportTicket.templateID || ''}
                        onChange={e => this.updateFields({ templateID: e.target.value })}
                    >
                        {templates.map(stt =>
                            <option key={stt.id} value={stt.id}>
                                {stt.title}
                            </option>
                        )}
                        <option value="">Something else</option>
                    </select>
                    {!supportTicket.templateID &&
                        <input
                            className="form-control"
                            value={supportTicket.title || ''}
                            onChange={e => this.updateFields({ title: e.target.value })}
                            placeholder="Please write a summary of your request here..."
                        />
                    }
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Please provide as much detail about your request as possible</Form.Label>
                    <ExpandingTextArea
                        rows={3}
                        className="form-control"
                        value={supportTicket.description || ''}
                        onChange={e => this.updateFields({ description: e.target.value })}
                    />
                </Form.Group>
            </>}

        </>);
    }
    
}

export default SubmitSupportTicketModal;